export function round1(val: number): string {
    return (Math.round(val * 10) / 10).toFixed(1);
}
